module.exports = __webpack_public_path__ + "assets/img/6_655_big.08189046.jpg";